import { useLocation } from "react-router-dom";
export function useQuery() {
    var params = new URLSearchParams(useLocation().search);
    var keys = {};
    params.forEach(function (value, key) {
        keys[key] = value;
    });
    return keys;
}
